import { ASSET_MAX_BYTES, MIB } from '@shared/media/uploadPolicy';
import { createFfmpegVideoTranscoder } from './ffmpegVideoTranscoder';
import { MediaProcessingScheduler } from './scheduler';
import { runVideoFeasibilitySpike, type ProcessedVideo } from './videoProcessor';

export const ARTICLE_VIDEO_PROCESSING_BUDGET = {
  maxInputBytes: 100 * MIB,
  maxDurationMs: 3 * 60 * 1000,
  maxPixels: 3840 * 2160,
  maxOutputBytes: ASSET_MAX_BYTES,
} as const;

const scheduler = new MediaProcessingScheduler();
const transcode = createFfmpegVideoTranscoder({
  outputMimeType: 'video/mp4',
  maxOutputBytes: ASSET_MAX_BYTES,
});

/** Production article-video path. It never returns the selected source file. */
export function processArticleVideo(file: File, signal?: AbortSignal): Promise<ProcessedVideo> {
  return scheduler.enqueue({ kind: 'video', signal }, () => runVideoFeasibilitySpike({
    file,
    budget: ARTICLE_VIDEO_PROCESSING_BUDGET,
    contract: {
      allowedMimeTypes: ['video/mp4', 'video/webm'],
      maxOutputBytes: ASSET_MAX_BYTES,
    },
    use: 'article',
    quality: 'standard',
    transcode,
    signal,
  }));
}
